import { getLang } from "helpers/themeHelpers";

export const linkWeather = (city = null, country: string = null) => {
  const locale = getLang();
  const cityPart = city ? "/" + city[`uri_${locale}`] : "";
  if (process.env.NEXT_PUBLIC_CUSTOM_THEME==="shobiddak" || country === "ps") {
    return `${process.env.NEXT_PUBLIC_SHO_BIDAK_BASE_URL}/PalestineWeather`
  }
  return `/${locale}/${locale === "ar" ? "حالة-الطقس" : "weather"}${cityPart}`;
};

export const absoluteLinkToWeather = (city = null) => {
  return `${linkWeather(city)}`;
};
